module.exports = require("core-js/modules/es.object.define-property.js");